
$views = {
	
	_current_screen : '',
	_views_html : {},
	_unauthenticated_access_allowed: [
		'login',
		'activationsuccessful',
		'alreadyactivated',
		'accountexpired',
		'accountcreate',
		'accountresetpassword',
		'accountresetpasswordconfirm'
	],
	
	all : {
		
		permissionsDropdown : '',
		
		init : function() {
			
			/*if ($config.enableContributeOnlyPermissions) {
				$views.all.permissionsDropdown = '<select><option value="1">Read only</option><option value="2">Contribute only</option><option value="3" selected="selected">Read & contribute</option></select>';
			} else {*/
				$views.all.permissionsDropdown = '<select><option value="1">Read only</option><option value="3" selected="selected">Read & contribute</option></select>';
			/*}*/
			
			jQuery('.view_html').each(function(key, obj) {
				$views.all.iterator_id = jQuery(obj).attr('id');
				$views.all.iterator_tmpl = jQuery(obj).html();
				$views._views_html[$views.all.iterator_id] = $views.all.iterator_tmpl;
			});
			
			jQuery.each($views._views_html, function($key, $tmpl) {
				$tmpl = $tmpl.replace('[[user_controls]]', $views._views_html['tmpl_sub_user_controls']);
				$tmpl = $tmpl.replace('[[ultrasearch_dashboard]]', $views._views_html['tmpl_sub_ultrasearch_dashboard']);
				$tmpl = $tmpl.replace('[[help_controls]]', $views._views_html['tmpl_sub_help']);
				$views._views_html[$key] = $tmpl;
			});
			
		},
		
		display : function($pageName, $bodyId, $params) {
			
			// help title definitions
			$helpTitles = {
				dashboard:'Dashboard',
				foldermanager:'Manager Folders',
				teamsettings:'Team Settings',
				foldersettings:'Folder Settings',
				profilesettings:'Profile Settings',
				mailboxsettings:'Mailbox Settings',
				main:'Mail View'
			};
			
			// double-check that the user is trying to access a valid page
			if (!$views._views_html['tmpl_'+$pageName]) {
				$soupmail.notification.error('The page you attempted to access does not exist');
				$controllers[$config.defaultPage].display();
				return false;
			}
			
			// get the template html for the requested page
			$views.all.this_template = $views._views_html['tmpl_'+$pageName];
			
			// do some quick templating of macros
			$views.all.this_template = $views.all.this_template.replace(/\[\[username\]\]/gi, $models.login.getFullName());
			$views.all.this_template = $views.all.this_template.replace(/\[\[help-heading\]\]/gi, $helpTitles[$pageName]);
			
			// change the page we are looking at
			if ($pageName == 'login') {
				jQuery('#login_page').show();
				jQuery('#body_html').hide().html('');
			} else {
				jQuery('#login_page').hide();
				jQuery('#body_html').show().html($views.all.this_template);
				jQuery('#ie6_compatibility_warning').remove();
			}
			jQuery('body').removeClass().addClass('page-'+$pageName).attr('id', $bodyId);
			this._current_screen = $pageName;
			
			// are we not viewing the login screen?
			if ($pageName != 'login') {
				jQuery('.login-page').hide();
			}
			
			// remove existing login form submit binding - this is IMPORTANT, to prevent multiple API calls from happening, and to prevent much javascript confusion!!!
			jQuery('#login_form').unbind('submit');
			
			// re-add the event handler to the login form
			jQuery('#login_form').submit(function() {
				var $username = jQuery('#username').val();
				var $password = jQuery('#password').val();
				$controllers.login.login($username, $password);
				return false;
			});
			
			// show the help text for this page
			jQuery('#help .content').html(jQuery('#help-content').html());
			
			// cancel any auto-refresh timers that we have set
			clearInterval($controllers.dashboard.refreshTimer);
			
			// various event handlers on the main page are defined in this function
	// TODO: clean this up / move this call to a more specific place, like inside $controllers.main.display()
			$controllers.main.setupEventHandlers();
			
			// bind a whole bunch of generic event handlers throughout the interface
			jQuery.each($controllers, function($controllerName, $controllerFunction) {
				jQuery('.go-to-page-'+$controllerName).unbind();
				jQuery('.go-to-page-'+$controllerName).click(function(e) {
					$controllers[$controllerName].display();
					e.preventDefault();
				});
			});
			jQuery('.action-help').click(function(e) {
				$controllers.all.help();
				e.preventDefault();
			});
			jQuery('.action-logout').click(function(e) {
				$controllers.login.logout();
				e.preventDefault();
			});
			
			// add a classname to the body to assist with styling for mac vs pc
			jQuery('body').addClass('platform-' + ((navigator.userAgent.indexOf('Mac OS') != -1) ? 'mac' : 'pc') );
			
			// dashboard tooltips
			jQuery('.toolbar div[rel=tipsy]').tipsy({live: true, fade: true, gravity: 's'});
			jQuery('.folder-icon[rel=tipsy]').tipsy({live: true, fade: true, gravity: 's', offset: '5'});
			// folder manager folder tooltips
			jQuery('.name[rel=tipsy]').tipsy({live: true, fade: true, gravity: 'e', offset: '5'});
			jQuery('.email[rel=tipsy]').tipsy({live: true, fade: true, gravity: 'e', offset: '5'});
			jQuery('.foldermanager_user_perms_email[rel=tipsy]').tipsy({live: true, fade: true, gravity: 'e', offset: '5'});
			// team settings tooltips
			jQuery('.teamsettings_user_email[rel=tipsy]').tipsy({live: true, fade: true, gravity: 'e', offset: '5'});
			// mailbox settings tooltips
			jQuery('.settings-container li[rel=tipsy]').tipsy({live: true, fade: true, gravity: 'e', offset: '10'});
			
			// generic tooltips
			jQuery('a[rel=tipsy]').tipsy({live: true, fade: true, gravity: 's'});
			jQuery('div[rel=tipsy]').tipsy({live: true, fade: true, gravity: 'e'});
			jQuery('span[rel=tipsy]').tipsy({live: true, fade: true, gravity: 'e'});
			
			jQuery('#global-search').focus(function(e) {
				jQuery('#global-search').css({'color': '#000'});
			});
			
			jQuery('#global-search').focusout(function(e) {
				var $val = jQuery('#global-search').val();
						
				if ($val){
					jQuery('#global-search').css({'color': '#000'});
				} else {
					jQuery('#global-search').css({'color': '#c2c2c2'});
				}
			});
			
			// global search/filter control, only create it if it doesn't already exist
			//if (!$views.all.globalsearch) {
				if ($views.all.globalsearch) {
					$views.all.globalsearch.destroy();
				}
				$views.all.globalsearch = new $soupmail.control.searchfilter({
					model : 'search',
					selector : '#global-search',
					listArrayKey : ['emails', 'email_addresses', 'folders', 'tags'],
					maxResults : 10,
					column : { name:'email', cssclass:'email', layout:'{first_name} {last_name} &lt;{email}&gt;' },
					nonFilterableModel_fallback_otherColumns : ['first_name', 'last_name'],
					dataItemsWrapperStart : '<h2 class="people">Team Members</h2>',
					
					onChange : '',
					onResultsLoaded : '',
					requestDelay : 100,		// minimum delay time (milliseconds) between HTTP requests, so as to not overload the server
					minCharactersRequired : 3,
					defaultSearchboxValue : 'New Global Search...'
				});
			//}
			
			// logging
			console.log('NOW ON PAGE: '+$pageName);
			
		},
		
		getCurrentScreen : function() {
			
			return this._current_screen;
			
		},
		
		// URL-based auth function : returns boolean
		authenticationRequiredForUrl : function($url) {
			var authenticationRequired = true;
			jQuery.each($views._unauthenticated_access_allowed, function(index, viewname) {
				if ($url.indexOf('/'+viewname) >= 0) {
					authenticationRequired = false;
				}
			});
			return authenticationRequired;
		},
		
		// VIEW-based auth function (recommended) : returns boolean
		authenticationRequiredForView : function($viewname) {
			return (jQuery.inArray($viewname, $views._unauthenticated_access_allowed) < 0);
		},
		
		
		
// TODO - REVIEW - NEED TO DEPRECATE & REPLACE WITH BETTER SOLUTIONS
		handleLoadedAjaxData : function($ajaxHtmlForDiv, $target, $appendNewDataToExisting) {
			
			if ($appendNewDataToExisting == true) {
				jQuery($target).html( jQuery($target).html() + $ajaxHtmlForDiv );
			} else {
				jQuery($target).html($ajaxHtmlForDiv);
			}
			
			jQuery($target).removeClass('loading-animation');
			
			if (jQuery(".soupmail-main-previewpane .body").size() > 0) {
				jQuery(".soupmail-main-previewpane .body").css('min-height', (jQuery(".soupmail-main-previewpane").height() - jQuery(".soupmail-main-previewpane .headers").height() - 30) + 'px');
			}
			
		},
		
		removeDuplicatedRows : function($selector, $attribute) {
			
			var $validIDs = [];
			jQuery($selector).each(function() {
				var $value = jQuery(this).attr($attribute);
				if (jQuery.inArray($value, $validIDs) == -1) {
					$validIDs.push($value);
				} else {
					console.log('DUPLICATE ROW DETECTED: now removing '+$attribute+'="'+$value+'"');
					jQuery(this).remove();
				}
			});
			
		},
		
// TODO - REVIEW - IS THIS NEEDED?
		bindClickHandlersToItems : function() {
			
			jQuery(".email-list-item").click(function(e) {
				if (jQuery("body").hasClass("phone-mode")) {
					document.location.href = jQuery(this).children("h3").children("a").attr("rel");
				} else {
					jQuery(".email-list-item.active").removeClass("active");
					jQuery(this).addClass("active");
					$views.all.scrollToTop();
				}
			});
			
			jQuery('.email-list-item').click(function(e) {
				var $emailId = jQuery(this).attr('data-id');
				var $emailSubject = jQuery(this).children('.subject').text();
				var $emailFolderId = jQuery(this).attr('data-folder-id');
				if (($views.all.getCurrentScreen() == 'main') && !jQuery(this).hasClass('ultrasearch-list-item')) {
					$models.main.getEmailPreview($emailId);
				} else {
					$controllers.main.viewEmail($emailId, $emailSubject, $emailFolderId);
				}
				e.preventDefault();
			});
			
			jQuery('.email-list-item a').click(function(e) {
				e.preventDefault();
			});
			
		},
		
		scrollToTop : function() {
			jQuery("html,body").animate({ scrollTop: 0 }, 500, "swing");
		},
		
		/* SPECIAL HACKY SOLUTION FOR VISUAL PROBLEM IN IE10 - refer #1131 */			
		applyBorder : function($selector) {
			
			jQuery($selector).removeClass('with-border');
			if (jQuery.browser.msie) {
				setTimeout(function() {
					jQuery($selector).addClass('with-border');
				}, 40);
			} else {
				jQuery($selector).addClass('with-border');
			}
			
		}
		
	}
};

// DO NOT REMOVE - USED FOR TESTING PURPOSES!
$views.tests = {
	display : function() {}
}

// IS THIS NEEDED?
$views.login = {};



// WEBPACK FOOTER //
// ./src/js/views/base.views.js